import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { http } from './helpers/http';
import { v4 as uuidv4 } from 'uuid';

sessionStorage.setItem(http.sessionName, uuidv4());

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
